import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl/dist';
import { ALL_USER_ROLES } from '../../../constants/roles/userRoleTypes.js';

import { changeLang } from '../../../actions/common/actionCreators';
import { configs } from '../../../constants/configs/configs';
import { adjustUTCToLocalTime } from '../../../utils/dates/dateMethods.js';
import { nowUtil } from '../../../utils/dates/date.utils.ts';
import { YYYY } from '../../../utils/dates/dateFormats.utils.ts';

const New_MexicoFooter = props => {

    const {
        actions,
        environment: {
            devEnvironment,
            exchangeName,
            links: {
                PRIVACY_POLICY,
                SIGNUP_AGENCY,
                SIGNUP_AGENT_BROKER,
                SIGNUP_ENROLLMENT_ENTITIES
            },
            localDates: {
                timezoneOffsetMs=0,
                dstSavingsMs=0,
                serverDateInUTC,
                timezone,
            },
            user,
            language
        },
    } = props;

    const {
        endpoints
    } = configs;

    const { sDate, sTime } = adjustUTCToLocalTime(serverDateInUTC, timezoneOffsetMs, dstSavingsMs);
    const currentYear = nowUtil(YYYY);
    const intlApi = useIntl();

    const src = global.__ENV__.PRODUCTION ? '/hix/resources/img/logo_nm_white.png' : '/assets/images/logo_nm_white.png';

    const preventLanguageChange = (url) => {
        if( language != 'en') {
            actions.changeLang(endpoints.CHANGE_LANGUAGE.processReplacements({ language: 'en' })).then(function() {
                window.location.href = url;
            });
        } else {
            window.location.href = url;
        }       
    };


    return(
        <Fragment>
            <footer id="footer--nm" className="usa-footer" role="contentinfo">
                <div className="usa-footer-primary-section gi-footer__container">
                    <div className="usa-grid usa-footer__primary-section gi-footer__primary-section">
                        <a href='#' className="gi-footer__image">
                            <img
                                src = { src }
                                alt='Bewell'
                            />
                        </a>
                        <div className="gi-footer__info">
                            <FormattedMessage id='footer.copyright' values={{  date: currentYear, exchangeName }}/><sup>&#174;</sup>
                        </div>
                        <a target="_blank" className="gi-footer__link" href={ PRIVACY_POLICY } title={ intlApi.formatMessage({ id: 'footer.privacy_policy.title' }) } rel="noopener noreferrer">
                            <FormattedMessage id='footer.privacy_policy'/>
                        </a>
                    </div>
                </div>
                {
                    devEnvironment &&
                    <div className="gi-footer__dev-container">
                        <div className="gi-footer__primary-section">
                            <div className="gi-footer__info gi-footer__info-heading">Dev Footer</div>
                            {
                                (user === null || user.role === ALL_USER_ROLES.INDIVIDUAL) &&
                                <Fragment>
                                    <a className="gi-footer__link" href='#' onClick={ () => preventLanguageChange(SIGNUP_AGENCY) }><FormattedMessage id='footer.agency' /></a>
                                    <a className="gi-footer__link" href='#' onClick={ () => preventLanguageChange(SIGNUP_AGENT_BROKER) }><FormattedMessage id='footer.agent_broker' /></a>
                                    <a className="gi-footer__link" href='#' onClick={ () => preventLanguageChange(SIGNUP_ENROLLMENT_ENTITIES) }><FormattedMessage id='footer.enrollment_entities' /></a>
                                </Fragment>
                            }
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_date' values={{ date: sDate }}/></div>
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_time' values={{ time: `${sTime} ${timezone}` }}/></div>
                        </div>
                    </div>
                }
            </footer>
        </Fragment>

    );
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeLang
    }, dispatch)
});

export default connect(null, mapDispatchToProps)(New_MexicoFooter);
